import { MapPin, Zap, Users, Award } from 'lucide-react'
import Reveal from './Reveal'
import CrateMark from './CrateMark'

const STATS = [
  { v: '$1,500', l: 'Website packages from' },
  { v: '< 7', l: 'Days average delivery' },
  { v: '100%', l: 'Melbourne based' },
]

const VALUES = [
  { icon: MapPin, title: 'Melbourne local', desc: 'Based here, available to meet, and I understand your customers because I live here too.' },
  { icon: Zap, title: 'Fixed pricing', desc: 'You know the exact price before we start. No hourly surprises, no scope creep.' },
  { icon: Users, title: 'Small business only', desc: 'Tradies, cafes, clinics, and local service businesses. No enterprise, no bloat.' },
  { icon: Award, title: 'Fast and professional', desc: 'Most sites live in under a week. Mobile-friendly, SEO-ready, and tested before handover.' },
]

const COMPARE = [
  { h: 'vs Agencies', d: 'Agencies charge $5,000+ and take months. You get the same professional result in days, for a fraction of the price.' },
  { h: 'vs Freelancers', d: 'Cheap overseas freelancers disappear after payment. I am local, accountable, and a phone call away.' },
  { h: 'vs DIY', d: 'Wix and Squarespace look like templates because they are. A custom site makes your business look real.' },
]

const About = () => {
  return (
    <section id="about" className="relative bg-cream-deep/50 py-24 lg:py-32">
      <div className="mx-auto max-w-container px-5 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          {/* Founder card — replace the inner block with a real photo when available */}
          <Reveal>
            <div className="relative">
              <div className="relative overflow-hidden rounded-xl2 bg-ink p-8 text-cream shadow-lift">
                <div className="bg-fine-grid absolute inset-0 opacity-[0.06]" />
                <div className="relative">
                  <div className="flex items-center gap-4">
                    <div className="grid h-16 w-16 place-items-center rounded-2xl bg-gold font-display text-3xl font-extrabold text-white">
                      A
                    </div>
                    <div>
                      <p className="font-display text-xl font-bold">Afshan</p>
                      <p className="text-sm text-cream/60">Founder, CrateWeb</p>
                    </div>
                    <CrateMark light className="ml-auto h-9 w-9" />
                  </div>
                  <p className="mt-8 font-display text-2xl font-bold leading-snug">
                    "I answer my own phone, and I deliver on time. That is the whole pitch."
                  </p>
                  <div className="mt-8 grid grid-cols-3 gap-4 border-t border-cream/15 pt-6">
                    {STATS.map((s) => (
                      <div key={s.l}>
                        <p className="font-display text-2xl font-extrabold text-gold-bright">{s.v}</p>
                        <p className="mt-1 text-[0.72rem] leading-tight text-cream/55">{s.l}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Story */}
          <Reveal delay={0.08}>
            <h2 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl">
              Melbourne-based. Small-business focused.
            </h2>
            <div className="mt-6 space-y-4 text-lg text-ink-soft">
              <p>
                I am Afshan, founder of CrateWeb. I started this because too many Melbourne small
                businesses were stuck: paying $5,000+ to agencies for a basic site, or getting burned
                by overseas freelancers who vanished after payment.
              </p>
              <p>
                I build websites and manage Google Business Profiles for local businesses at fixed
                prices. No retainers you cannot leave, no hourly billing, no outsourcing. You know the
                price before we start, and you own everything when we are done.
              </p>
            </div>

            <div className="mt-9 grid gap-5 sm:grid-cols-2">
              {VALUES.map((v) => (
                <div key={v.title} className="flex gap-3">
                  <span className="grid h-10 w-10 flex-shrink-0 place-items-center rounded-xl bg-gold/10 text-gold">
                    <v.icon className="h-5 w-5" strokeWidth={1.75} />
                  </span>
                  <div>
                    <p className="font-display font-bold text-ink">{v.title}</p>
                    <p className="mt-1 text-[0.88rem] leading-relaxed text-ink-soft">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        {/* Comparison */}
        <Reveal delay={0.05} className="mt-16">
          <h3 className="font-display text-2xl font-bold text-ink">Why Melbourne businesses choose CrateWeb</h3>
          <div className="mt-6 grid gap-px overflow-hidden rounded-xl2 border border-[var(--line)] bg-[var(--line)] md:grid-cols-3">
            {COMPARE.map((c) => (
              <div key={c.h} className="bg-paper p-7">
                <p className="font-display text-xl font-extrabold text-gold">{c.h}</p>
                <p className="mt-3 text-[0.95rem] leading-relaxed text-ink-soft">{c.d}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  )
}

export default About
